import { Textarea } from "@/components/ui/textarea";
import { YesNo, Field } from "@/components/apply/Steps";

export const DISCLOSURE_QS = [
  { q: "has_vices", d: "vices_description", id: "apply-vices",
    label: "Does this horse have any known vices or behavioural issues?",
    descLabel: "Please describe the vices or behavioural issues.",
    askErr: "Please tell us whether the horse has any known vices or behavioural issues.",
    descErr: "Please describe the vices or behavioural issues.", short: "Vices / Behavioural Issues" },
  { q: "has_health_issues", d: "health_description", id: "apply-health",
    label: "Does this horse have any known soundness or health issues?",
    descLabel: "Please describe any injuries, lameness, health concerns, treatments, or maintenance requirements.",
    askErr: "Please tell us whether the horse has any known soundness or health issues.",
    descErr: "Please describe the soundness or health issues.", short: "Soundness / Health Issues" },
];

export function HealthBehaviour({ horse, set, errors }) {
  const pick = ({ q, d }) => (v) => {
    if (v === "no" && (horse[d] || "").trim() && !window.confirm("Changing this to No will clear the description you entered. Continue?")) return;
    set({ ...horse, [q]: v, ...(v === "no" ? { [d]: "" } : {}) });
  };
  return (
    <div data-testid="apply-health-behaviour" className="rounded-xl border border-stone-200 bg-white/60 p-3 space-y-4">
      <div className="text-sm font-semibold text-stone-800">Horse Health &amp; Behaviour</div>
      {DISCLOSURE_QS.map((x) => (
        <div key={x.q} className="space-y-3">
          <YesNo id={x.id} label={x.label} value={horse[x.q]} onChange={pick(x)} error={errors[x.q]} />
          {horse[x.q] === "yes" && (
            <Field id={`${x.id}-description`} label={x.descLabel} required error={errors[x.d]}>
              <Textarea id={`${x.id}-description`} data-testid={`${x.id}-description`} rows={4} value={horse[x.d] || ""} aria-invalid={!!errors[x.d]}
                onChange={(e) => set({ ...horse, [x.d]: e.target.value })}
                className={`text-base bg-white border-stone-300 focus-visible:ring-amber-800 ${errors[x.d] ? "border-red-400" : ""}`} />
            </Field>
          )}
        </div>
      ))}
    </div>
  );
}

export function validateHealth(h) {
  const e = {};
  DISCLOSURE_QS.forEach(({ q, d, askErr, descErr }) => {
    if (h[q] !== "yes" && h[q] !== "no") e[q] = askErr;
    else if (h[q] === "yes" && !(h[d] || "").trim()) e[d] = descErr;
  });
  return e;
}

export const disclosureRows = (h) => DISCLOSURE_QS.flatMap(({ q, d, short }) => [
  [short, h[q] === "yes" ? "Yes" : h[q] === "no" ? "No" : ""],
  ...(h[q] === "yes" ? [[`${short} — Details`, h[d]]] : []),
]);
